import { Button, Grid, Stack } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { FormDropDown } from '../../common/Form/FormDropdown';
import { FormAutoComplete } from '../../common/Form/FormAutoComplete';
import { getData } from '../../../DataAccessLayer';
import { ats } from '../../../DataAccessLayer/services';
import { FormTextField } from '../../common/Form/FormTextField';

export default function Filter(props) {
  const actionStatusOptions = ['SUCCESS', 'FAILED', 'PENDING'];
  const [actionTakenByOptions, setActionTakenByOptions] = useState([]);
  const [actionsOptions, setActionsOptions] = useState([]);
  const [description, setDescription] = useState('');
  const [descriptionValue, setDescriptionValue] = useState('');
  const [actionTakenBy, setActionTakenBy] = useState(props.filters.midas);
  const [action, setAction] = useState(props.filters.action);
  const [status, setStatus] = useState(props.filters.status);

  const DESCRIPTION_DEBOUNCE_TIMEOUT = 2000;

  // useEffect to fetch filters data
  useEffect(() => {
    const fetchActionsOptions = async () => {
      try {
        const [actionTypeRes, usernameRes] = await Promise.all([
          getData(
            ats.actions({
              crn: props?.crn,
              termCode: props?.termCode,
            }),
          ),

          getData(
            ats.actionTakenBy({
              crn: props?.crn,
              termCode: props?.termCode,
            }),
          ),
        ]);

        setActionsOptions(Array.isArray(actionTypeRes) ? actionTypeRes : []);
        setActionTakenByOptions(Array.isArray(usernameRes) ? usernameRes : []);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchActionsOptions();
  }, [props?.crn, props?.termCode]);

  // Update the filters when status, action or actionTakenBy changes
  useEffect(() => {
    props.updateFilters({
      status,
      action,
      midas: actionTakenBy,
      description,
    });
  }, [status, action, actionTakenBy, description]);

  // Add 2s debounce for description field to trigger the search
  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setDescription(value);
      }, DESCRIPTION_DEBOUNCE_TIMEOUT),
    [],
  );

  const onClearFields = () => {
    setStatus('');
    setAction('');
    setActionTakenBy('');
    setDescription('');
    setDescriptionValue('');
  };

  const id = props.id;

  return (
    <React.Fragment>
      <Stack id={`${id}__stack_wrapper`} direction={'column'} gap={2} mt={2}>
        {
          <Grid
            id={`${id}__grid_container`}
            container
            direction={{ xs: 'column', sm: 'column', xl: 'row' }}
            spacing={2}
            sx={{
              justifyContent: 'center',
            }}
          >
            <Grid item xs={12} xl={3} id={`${id}__grid_item_description`}>
              <FormTextField
                id={`${id}__inputText_description`}
                name="description"
                value={descriptionValue}
                label="Description"
                placeholder="Enter any keyword"
                onChange={(value) => {
                  setDescriptionValue(value);
                  debouncedSearch(value);
                }}
                labelGridProps={{
                  xs: 0,
                }}
                inputGridProps={{
                  xs: 12,
                }}
              />
            </Grid>

            <Grid item xs={12} xl={4} id={`${id}_grid_item_action`}>
              <FormAutoComplete
                id={`${id}__selectAutoComplete_action`}
                clearIcon={true}
                options={actionsOptions}
                freeSolo
                value={action}
                getOptionLabel={(option) => option || ''}
                onChange={(e, value = '') => {
                  setAction(value);
                }}
                placeholder="Select"
                size="small"
                sx={{ width: '100%' }}
                label="Action"
                inputGridProps={{ xs: 12 }}
                labelGridProps={{ xs: 12 }}
                textAlign={{ xs: 'start' }}
              />
            </Grid>

            <Grid item xs={12} xl={3} id={`${id}__grid_item_actionStatus`}>
              <FormDropDown
                id={`${id}__select_actionStatus`}
                name="selectedActionStatus"
                options={actionStatusOptions.map((status) => ({
                  value: status,
                  label: status,
                }))}
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
                label="Action Status"
                ariaLabel="action status dropdown"
                labelGridProps={{
                  xs: 0,
                }}
                inputGridProps={{
                  xs: 12,
                }}
              />
            </Grid>

            <Grid item xs={12} xl={2} id={`${id}__grid_item_actionTakenBy`}>
              <FormAutoComplete
                id={`${id}__selectAutoComplete_actionTakenBy`}
                clearIcon={true}
                options={actionTakenByOptions}
                freeSolo
                value={actionTakenBy}
                getOptionLabel={(option) => option || ''}
                onChange={(e, value = '') => {
                  setActionTakenBy(value);
                }}
                placeholder="Select"
                size="small"
                sx={{ width: '100%' }}
                label="Action Taken By"
                inputGridProps={{ xs: 12 }}
                labelGridProps={{ xs: 12 }}
                textAlign={{ xs: 'start' }}
              />
            </Grid>

            <Grid
              container
              item
              xs={12}
              xl={12}
              justifyContent={'flex-end'}
              gap={1}
              direction={{ xs: 'column-reverse', xl: 'row' }}
              id={`${id}__grid_item_container_actions`}
            >
              {props.showClearFieldsButton && (
                <Grid item id={`${id}__grid_item_actions`}>
                  <Button
                    id={`${id}__button_clearFields`}
                    className="myOdu__button secondary"
                    variant="outlined"
                    onClick={onClearFields}
                    fullWidth
                    disabled={
                      !action && !descriptionValue && !description && !actionTakenBy && !status
                    }
                  >
                    Clear
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        }
      </Stack>
    </React.Fragment>
  );
}
